import { Component, ErrorInfo, ReactNode } from 'react'

import { reportClientError } from '@services/client-error.service'


type ErrorBoundaryProps = {
    children: ReactNode
}

type ErrorBoundaryState = {
    hasError: boolean
}

export default class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
    state: ErrorBoundaryState = { hasError: false }

    static getDerivedStateFromError(): ErrorBoundaryState {
        return { hasError: true }
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        reportClientError('react.error-boundary', error, {
            componentStack: errorInfo.componentStack,
        })
    }

    render() {
        if (this.state.hasError) {
            return (
                <main style={{ minHeight: '100vh', padding: '32px', display: 'grid', placeItems: 'center', background: 'var(--background_primary)' }}>
                    <div role='alert' style={{ maxWidth: '560px', color: 'var(--color_txt_default)', textAlign: 'center' }}>
                        <h1 style={{ margin: '0 0 12px', fontSize: '24px' }}>Ошибка интерфейса</h1>
                        <p style={{ margin: 0, fontSize: '15px' }}>Обновите страницу. Ошибка зафиксирована для диагностики.</p>
                    </div>
                </main>
            )
        }

        return this.props.children
    }
}